import type { Ordering } from 'fp-ts/lib/Ordering';

export const makeCompareEnumerated =
  <T>(enumerate: (a: T) => number) =>
  (x: T, y: T): Ordering => {
    const ex = enumerate(x);
    const ey = enumerate(y);
    if (ex < ey) {
      return -1;
    }
    if (ex > ey) {
      return 1;
    }
    return 0;
  };
